// removed by extract-text-webpack-plugin
module.exports = {"category":"_1PJ-kRfrIJW1dkwbdfed9a"};


//////////////////
// WEBPACK FOOTER
// ./components/categories.scss
// module id = 1592
// module chunks = 0